/**
 * Filters functionalities.
 */
export function filterActions() {
	const $tableHeaderContainer = $( '.m__dashboard-header' );
	const $tableContainer = $( '.m__dashboard-table' );
	const $filter = $tableHeaderContainer.find( '.filter' );

	if ( !$filter.length || !$tableContainer.length ) {
		return;
	}

	const $filterOptions = $tableHeaderContainer.find( '.filter-submenu-right-item' );

	$filterOptions.on( 'click', function updateTable() {
		const $this = $( this );
		const filterby = $this.data( 'filterby' );
		const filtertext = $this.data( 'filtertext' );
		const data = {
			offset: 0,
			filterby,
			filtertext,
		};
		$tableContainer.trigger( 'tableUpdate', data );
		$tableHeaderContainer.trigger( 'filtersActive' );
	});
}